import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = "https://www.internationalresearcholympiad.org";
const DEFAULT_OG = `${BASE}/og-image.png`;

/**
 * Per-page SEO tags. Sets <title>, meta description, canonical, and
 * Open Graph / Twitter overrides so each route is distinct in search
 * results and link previews.
 *
 * Props:
 *  - title:       page title (the "| International Research Olympiad" suffix is added automatically)
 *  - description: meta + OG description
 *  - path:        canonical path, e.g. "/winners-hub" (defaults to "/")
 *  - canonical:   canonical path when this route is an alias of another page
 *  - noindex:     keep the page out of search results
 *  - image:       absolute OG image URL (defaults to the site OG image)
 */
function Seo({ title, description, path = "/", canonical, image = DEFAULT_OG, noindex = false }) {
  const fullTitle = title
    ? `${title} | International Research Olympiad`
    : "International Research Olympiad | Global STEM Research Competition";
  const url = `${BASE}${canonical || path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default Seo;
